import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Table, InputGroup } from 'react-bootstrap';
import { FaPlus, FaTrash } from 'react-icons/fa';

const ModalAjustesManuales = ({ show, onHide, empleado, ajustesIniciales, onGuardar }) => {
  const [ajustes, setAjustes] = useState({
    ingresos: [],
    descuentos: [],
    renta_5ta_override: undefined,
    redondeo_centimos: 0
  });

  useEffect(() => {
    if (show) {
      setAjustes(ajustesIniciales || {
        ingresos: [],
        descuentos: [],
        renta_5ta_override: undefined,
        redondeo_centimos: 0
      });
    }
  }, [show, ajustesIniciales]);

  const agregarIngreso = () => {
    setAjustes({
      ...ajustes,
      ingresos: [...ajustes.ingresos, { motivo: '', monto: 0, afecto: true }]
    });
  };

  const agregarDescuento = () => {
    setAjustes({
      ...ajustes,
      descuentos: [...ajustes.descuentos, { motivo: '', monto: 0 }]
    });
  };

  const removerIngreso = (index) => {
    const nuevos = [...ajustes.ingresos];
    nuevos.splice(index, 1);
    setAjustes({ ...ajustes, ingresos: nuevos });
  };

  const removerDescuento = (index) => {
    const nuevos = [...ajustes.descuentos];
    nuevos.splice(index, 1);
    setAjustes({ ...ajustes, descuentos: nuevos });
  };

  const handleGuardar = () => {
    onGuardar(empleado.empleado_id, ajustes);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Ajustes Manuales - {empleado?.nombres}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5>Ingresos Adicionales (Reintegros, Bonos Especiales)</h5>
        <Table size="sm">
          <thead>
            <tr>
              <th>Motivo (Ej: Reintegro)</th>
              <th>Monto</th>
              <th>Afecto (AFP/Quinta)</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {ajustes.ingresos.map((ing, idx) => (
              <tr key={idx}>
                <td>
                  <Form.Control 
                    value={ing.motivo} 
                    onChange={(e) => {
                      const n = [...ajustes.ingresos];
                      n[idx].motivo = e.target.value;
                      setAjustes({...ajustes, ingresos: n});
                    }}
                  />
                </td>
                <td>
                  <Form.Control 
                    type="number" 
                    value={ing.monto}
                    onChange={(e) => {
                      const n = [...ajustes.ingresos];
                      n[idx].monto = parseFloat(e.target.value);
                      setAjustes({...ajustes, ingresos: n});
                    }}
                  />
                </td>
                <td>
                  <Form.Check 
                    type="switch"
                    id={`switch-afecto-${idx}`}
                    checked={ing.afecto}
                    onChange={(e) => {
                      const n = [...ajustes.ingresos];
                      n[idx].afecto = e.target.checked;
                      setAjustes({...ajustes, ingresos: n});
                    }}
                  />
                </td>
                <td>
                  <Button variant="outline-danger" size="sm" onClick={() => removerIngreso(idx)}>
                    <FaTrash />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Button variant="outline-success" size="sm" onClick={agregarIngreso}>
          <FaPlus /> Agregar Ingreso
        </Button>

        <hr />

        <h5>Otros Descuentos (Préstamos, Judiciales, Otros)</h5>
        <Table size="sm">
          <thead>
            <tr>
              <th>Motivo (Ej: Judicial #001)</th>
              <th>Monto</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {ajustes.descuentos.map((desc, idx) => (
              <tr key={idx}>
                <td>
                  <Form.Control 
                    value={desc.motivo}
                    onChange={(e) => {
                      const n = [...ajustes.descuentos];
                      n[idx].motivo = e.target.value;
                      setAjustes({...ajustes, descuentos: n});
                    }}
                  />
                </td>
                <td>
                  <Form.Control 
                    type="number" 
                    value={desc.monto}
                    onChange={(e) => {
                      const n = [...ajustes.descuentos];
                      n[idx].monto = parseFloat(e.target.value);
                      setAjustes({...ajustes, descuentos: n});
                    }}
                  />
                </td>
                <td>
                  <Button variant="outline-danger" size="sm" onClick={() => removerDescuento(idx)}>
                    <FaTrash />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Button variant="outline-success" size="sm" onClick={agregarDescuento}>
          <FaPlus /> Agregar Descuento
        </Button>

        <hr />

        <Row>
          <Col md={6}>
            <h5>Ajuste Renta 5ta</h5>
            <Form.Group>
              <Form.Label>Monto Manual (Ignorar calculado)</Form.Label>
              <InputGroup>
                <Form.Control 
                  type="number" 
                  value={ajustes.renta_5ta_override !== undefined ? ajustes.renta_5ta_override : ''}
                  placeholder="Calculado automático"
                  disabled={ajustes.renta_5ta_override === undefined}
                  onChange={(e) => setAjustes({...ajustes, renta_5ta_override: parseFloat(e.target.value) || 0})}
                />
                <Button 
                  variant={ajustes.renta_5ta_override === undefined ? "outline-secondary" : "danger"}
                  onClick={() => setAjustes({...ajustes, renta_5ta_override: ajustes.renta_5ta_override === undefined ? 0 : undefined})}
                >
                  {ajustes.renta_5ta_override === undefined ? "Activar" : "Desactivar"}
                </Button>
              </InputGroup>
            </Form.Group>
          </Col>
          <Col md={6}>
            <h5>Ajuste de Céntimos (Redondeo)</h5>
            <Form.Group>
              <Form.Label>Ajuste Final (+/-)</Form.Label>
              <Form.Control 
                type="number" 
                step="0.01"
                value={ajustes.redondeo_centimos}
                onChange={(e) => setAjustes({...ajustes, redondeo_centimos: parseFloat(e.target.value) || 0})}
              />
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Cancelar</Button>
        <Button variant="primary" onClick={handleGuardar}>Aplicar Ajustes</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalAjustesManuales;
